import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';

export const CustomLabel = withStyles({
    label: {
        fontSize: '19px !important',
        marginTop: '10px'
    },
})(FormControlLabel);
